import Model, { belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StandardsSet from 'district-ui-client/models/standards-set'
import type StringTransform from 'district-ui-client/transforms/string'
import type BooleanTransform from 'district-ui-client/transforms/boolean'
import type DateTransform from 'district-ui-client/transforms/date'
import type { ExternalRosteringSource } from 'district-ui-client/services/external-rostering'

export default class District extends Model {
  @attr<StringTransform>('string') declare name: string

  @attr<StringTransform>('string') declare code: string

  @attr<BooleanTransform>('boolean') declare oneRosterEnabled?: boolean

  @attr<StringTransform>('string') declare externalRosteringSource?: ExternalRosteringSource

  @attr<BooleanTransform>('boolean') declare usesExternalRostering: boolean

  @attr<BooleanTransform>('boolean') declare isNewClasslink?: boolean

  @attr<DateTransform>('date') declare updatedAt?: Date

  @belongsTo<StandardsSet>('standards-set', { async: false, inverse: null })
  declare standardsSet?: StandardsSet;

  [Type] = 'district' as const
}
